// extracted by mini-css-extract-plugin
export default {"mainContainer":"main_mainContainer__01zd1","contactContainer":"main_contactContainer__KTW-Y","widgetContainer":"main_widgetContainer__Zrvuq"};